import {KTCard} from '../../../_metronic/helpers'
import {useGetPurchaserReport} from '../hooks/useGetPurchaserReport'
import PurchaserReportTable from '../sections/table/PurchaserReportTable'
import {PurchaserReportContext} from '../context'
import PurchaserReportsHeader from '../sections/header/PurchaserReportsHeader'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function PurchaserReport() {
  const {
    reportData: purchaserReportData,
    isLoading: isPurchaserReportLoading,
    filters,
    onSortingChange,
    handlePurchaserReportDateChange,
  } = useGetPurchaserReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('purchaser_by_supplier')

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('purchaser_by_supplier')

  const contextValue = {
    purchaserReportData,
    isPurchaserReportLoading,
    filters,
    onSortingChange,
    handlePurchaserReportDateChange,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  }

  return (
    <KTCard>
      <PurchaserReportContext.Provider value={contextValue}>
        <PurchaserReportsHeader />
        <PurchaserReportTable />
      </PurchaserReportContext.Provider>
    </KTCard>
  )
}

export default PurchaserReport
